
export default function WhyChooseUs() {

return(

<section className="why-section">

<div className="container">

<h2>Why Choose RelyOnne UK Limited?</h2>

<div className="why-grid">

<div>
<h3>✔ Premium Quality</h3>
<p>Products sourced from trusted manufacturers.</p>
</div>

<div>
<h3>✔ Competitive Pricing</h3>
<p>Excellent value without compromising quality.</p>
</div>

<div>
<h3>✔ Reliable Delivery</h3>
<p>Efficient logistics and dependable supply.</p>
</div>

<div>
<h3>✔ Sustainable Solutions</h3>
<p>Supporting environmentally responsible sourcing.</p>
</div>

</div>

</div>

</section>

);

}